import React from 'react';
import PropTypes from 'prop-types';
import Container from '../../layout/Container/Container';
import Row from '../../layout/Row/Row';
import Column from '../../layout/Column/Column';

/**
 * A component for displaying landing page information
 */
function HeroBlock({ title, meta, suffix, children }) {
  return (
    <div className="hero-block">
      <Container>
        {title && <h1 className={'hero-block__title'}>{title}</h1>}
        <Row>
          <Column sm={12} md={meta ? 8 : 12}>
            <div className="hero-block__content">{children}</div>
          </Column>
          {meta && (
            <Column sm={12} md={4}>
              {meta.map((item, index) => {
                return (
                  <div key={index} className="hero-block__meta">
                    <span>{item.key}</span> {item.value}
                  </div>
                );
              })}
              {suffix}
            </Column>
          )}
        </Row>
      </Container>
    </div>
  );
}

HeroBlock.propTypes = {
  /**
   * The title to display
   */
  title: PropTypes.string,
  /**
   * The metadata
   */
  meta: PropTypes.array,
  /**
   * The suffix component
   */
  suffix: PropTypes.node,
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default HeroBlock;
